import { httpStatusCode } from '@netpurpose/utils'
import axios from 'axios'
import { apiConfig } from '../config'
import { mapError, mapUserApiError } from '../errors'
import { getBaseUrl, log4XXApiErrors } from '../utils'
import { getToken, logout } from './auth'
import { attachAuthToken } from './requestInterceptors'

export const createApi = (baseUrl: string) => {
  const api = axios.create({
    baseURL: baseUrl,
  })

  api.interceptors.request.use(attachAuthToken)

  api.interceptors.response.use(
    (response) => response,
    async (error) => {
      log4XXApiErrors(error)
      if (error?.response?.status === httpStatusCode.unauthorized) {
        const token = await getToken(true)
        if (!token) {
          logout()
        }
      }

      if (baseUrl === getBaseUrl(apiConfig.usersHost)) {
        return Promise.reject(mapUserApiError(error.response))
      }

      return Promise.reject(mapError(error.response))
    },
  )

  return api
}
